import { categories } from "@/mocks/site";

export default function Categories() {
  return (
    <section id="category" className="py-14 md:py-20">
      <div className="container-site">
        <div className="mx-auto max-w-2xl text-center">
          <p className="mb-1 flex items-center justify-center gap-2 text-sm font-medium text-primary-700">
            <i className="ri-grid-fill"></i> 分类直达
          </p>
          <h2 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">瓜田分类</h2>
          <p className="mt-2 text-sm text-foreground-600">入口清晰，想去哪块瓜田直接进，不用大海捞针。</p>
        </div>

        <div className="mt-10 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {categories.map((c) => (
            <a
              key={c.key}
              href="#board"
              className="group flex items-start gap-4 rounded-2xl border border-background-200 bg-background-100/60 p-5 transition-colors hover:border-secondary-300 hover:bg-background-50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-secondary-500 text-background-50 transition-colors group-hover:bg-primary-500">
                <i className={`${c.icon} text-xl`}></i>
              </span>
              <div className="min-w-0 flex-1">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-bold text-foreground-900">{c.name}</h3>
                  <span className="whitespace-nowrap text-xs text-foreground-400">{c.count} 帖</span>
                </div>
                <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{c.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}